export default __webpack_public_path__ + "static/media/animatecard2.dbfdb0b3.jpg";